import { Component, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { MatIconRegistry } from "@angular/material/icon";
import { LanguagesService, ResizeWindowService } from "@ubisolutions/base";
import { notNull } from "@ubisolutions/base/utils";
import { AuthService } from "@auth/interfaces/IAuthService";
import { DomSanitizer } from "@angular/platform-browser";
import { UserSettingsService } from "@shared/business/services/user-settings.service";
import { filter, switchMap, take } from "rxjs";

@Component({
    selector: "app-root",
    imports: [RouterOutlet],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
    private matIconRegistry = inject(MatIconRegistry);
    private resizeService = inject(ResizeWindowService);
    private languagesService = inject(LanguagesService);
    private authService = inject(AuthService);
    private userSettingsService = inject(UserSettingsService);
    private readonly domSanitizer = inject(DomSanitizer);

    ngOnInit() {
        this.matIconRegistry.setDefaultFontSetClass("material-symbols-outlined");
        this.languagesService.init();
        this.addCustomMatIcons();
        this.authService.init();
        this.applyStoredLanguageOnLogin();
    }

    private applyStoredLanguageOnLogin() {
        this.authService.onLoginEvent$.pipe(
            switchMap(() => this.userSettingsService.getLanguage()),
            filter(notNull),
            take(1),
        ).subscribe(language => this.languagesService.setLanguage(language));
    }

    private addCustomMatIcons() {
        this.matIconRegistry.setDefaultFontSetClass("material-symbols-outlined");
        this.matIconRegistry.addSvgIconResolver((name, namespace) => {
            switch (namespace) {
                case "flags":
                    return this.domSanitizer.bypassSecurityTrustResourceUrl(
                        `i18n/countries/${name}.svg`,
                    );
                default:
                    return this.domSanitizer.bypassSecurityTrustResourceUrl(
                        `icon/material/${name}.svg`,
                    );
            }
        });
    }
}
